import { render, staticRenderFns } from "./PurchaseVanCollapseContent.vue?vue&type=template&id=658b7fce&scoped=true"
import script from "./PurchaseVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./PurchaseVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./PurchaseVanCollapseContent.vue?vue&type=style&index=0&id=658b7fce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b7fce",
  null
  
)

export default component.exports